<mat-progress-spinner
    mode="indeterminate"
    [class.mx-auto]="centered()"
    [attr.aria-label]="ariaLabel() | translate: ariaLabelParams()"
    [color]="color()"
    [diameter]="diameter()" />
